import { GuideTourForceClickHandIcon } from './GuideTourForceClickHandIcon'
import { getGuideTourForceClickAffordanceLayout } from './guideTourForceClickAffordanceLayout'
import type { SpotlightBounds } from './utils'
import * as S from './styles'

type GuideTourForceClickHintProps = {
  bounds: Pick<SpotlightBounds, 'width' | 'height'>
}

export const GuideTourForceClickHint = ({
  bounds,
}: GuideTourForceClickHintProps) => {
  const { centerX, centerY } = getGuideTourForceClickAffordanceLayout(
    bounds,
    S.FORCE_CLICK_AFFORDANCE_OVERFLOW_PX
  )

  return (
    <S.ForceClickHint data-testid="guide-tour-force-click-hint" aria-hidden>
      <S.ForceClickRippleStack $centerX={centerX} $centerY={centerY}>
        <S.ForceClickRippleRing $variant="primary" $delayMs={0} />
        <S.ForceClickRippleRing
          $variant="secondary"
          $delayMs={S.FORCE_CLICK_RIPPLE_STAGGER_MS}
        />
      </S.ForceClickRippleStack>
      <S.ForceClickHandWrap $centerX={centerX} $centerY={centerY}>
        <GuideTourForceClickHandIcon />
      </S.ForceClickHandWrap>
    </S.ForceClickHint>
  )
}
